import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Simple trick for testing forms full of checkboxes with django",
  "description": "",
  "published": "2011-12-02T00:00:00.000Z",
  "redirect_from": ["/blog/simple-trick-for-testing-forms-full-of-checkboxes-with-django/swizec/3098"],
  "categories": "Checkbox, django, Programming, python, Software testing, Tick (check mark), Uncategorized, Unit testing",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`In late 2011 I hope we can all agree that `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Unit_testing",
        "title": "Unit testing"
      }}>{`unit testing`}</a>{` is pretty important when creating websites or almost anything. Doesn't really matter whether you prefer a blackbox `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Integration_testing",
        "title": "Integration testing"
      }}>{`integration testing`}</a>{` approach or a strict unit testing style. What matters is that you have tests.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/12/300px-Series_of_build_lights4.jpg",
        "alt": "English: A series of build lights.",
        "title": "English: A series of build lights."
      }}></img></p>
    <p>{`But what do you do when you want to test a form with a bunch of checkboxes?`}</p>
    <p>{`You want to make sure all combinations of on/off tests are working. But with even just 6 checkboxes that's 2^6=64 test and ... well nobody in their right mind is going to write that many tests are they?`}</p>
    <p>{`Last weekend I came up with a simple solution to this problem, dare I say elegant.`}</p>
    <p>{`The approach is to make a list of checkboxes, then generate `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Binary_numeral_system",
        "title": "Binary numeral system"
      }}>{`binary numbers`}</a>{` from 0 to 2^(length of list). Then simply iterate over the generated binary numbers, pick all the checkboxes with a corresponding true bit in the number and run its test - the tests are lambda functions in a dictionary.`}</p>
    <p>{`My code was complicated slightly because I had two distinct sets of checkboxes that had to be tested separately-ish, but here's what this basically looks like in code.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`    _columns = ['job_code', 'location_in', 'location_out', 'shift_report']

    def checkboxes(self):
        checks = []

        for i in range(2**len(self._columns):
            column_switch = bin(j)[2:].rjust(4, '0')

            checks.append([name for (yes, name) in
                           zip(column_switch, self._columns) if int(yes)])

        return checks
`}</code></pre>
    <p>{`You also need to define the actual tests for all the checkboxes, deciding how thorough to be is a matter of personal taste, I like to test for the smallest possible symptom.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`_column_checks = {
            'job_code': {True: lambda r:
                             self.assert_('Job Code' in r.content,
                                          "no code column"),
                         False: lambda r:
                             self.assert_('Job Code' not in r.content,
                                          "is code column")},
# and so on (this example has been violently snipped, likely missing a } or two
`}</code></pre>
    <p>{`' in r.content, "no code column"), False: lambda r: self.assert`}{`_`}{`('Job Code`}</p>
    <p>{`' not in r.content, "is code column")}, # and so on`}</p>
    <p>{`And finally the whole thing becomes a simple loop`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`     for checkboxes in self.checkboxes():
          # do a bunch of posts to django to set everything up

          for check in _column_checks.keys():
                _column_checks[check][check in checkboxes['columns']](response)
`}</code></pre>
    <p>{`And that's it. Simple easily modifiable code to test every possible combination of all checkboxes in a form.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://writingtomarketing.wordpress.com/2011/09/15/4-steps-to-remove-the-share-andor-like-features/"
        }}>{`4 Steps to Remove the Share and/or Like Features`}</a>{` (writingtomarketing.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://ask.metafilter.com/160124/How-can-I-use-jQuery-show-and-hide-DIVs-based-on-checkboxes-in-a-submitted-form"
        }}>{`How can I use jQuery show and hide DIVs based on checkboxes in a submitted form?`}</a>{` (ask.metafilter.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://stackoverflow.com/questions/8177350/how-do-i-centre-this-checkbox"
        }}>{`How do I centre this checkbox?`}</a>{` (stackoverflow.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://stackoverflow.com/questions/8290408/how-to-use-javascript-to-select-a-row-of-radio-buttons-when-a-checkbox-is-select"
        }}>{`How to use javascript to select a row of radio buttons when a checkbox is selected`}</a>{` (stackoverflow.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=87906043-2b53-4237-bd94-c9fd53de2ca7",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      